import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

import { Background, MainContainer } from './layout-candidate-styled';
import { LayoutFooterCandidate } from './layout-candidate/footer-candidate/footer-candidate';
import { LayoutHeaderCandidate } from './layout-candidate/header-candidate/header-candidate';
import { QuizProfileContext } from './quiz-profile/context/QuizContext';

export const LayoutCandidateQuiz = ({ children, pageSettings, moduleId }) => {
  const { isAuthenticated } = Sebrae.useAuth();

  const { moduleSettings, user } = React.useContext(QuizProfileContext);

  return (
    <Background
      isAuthenticated={isAuthenticated}
      primaryColor={moduleSettings?.primaryColor}
      imgBackground={moduleSettings?.empretecGraphics}
    >
      <LayoutHeaderCandidate moduleId={user?.module?.id} />
      <MainContainer
        isAuthenticated={isAuthenticated}
        secondaryColor={moduleSettings?.secondaryColor}
      >
        {children}
      </MainContainer>
      <LayoutFooterCandidate />
    </Background>
  );
};
